<template>
  <div id="introduction">
    <div class="policy-title">Class Process Introduction</div>
    <div class="sub-title">1. Online Class Flow</div>
    <div class="flow-wrap">
      <div class="flow-block">
        <div class="flow-title">Before class<span></span></div>
        <div class="flow-text">
          <ul>
            <li>● Prepare a lesson(Website "preview" / Teacher APP "Textbook")</li>
            <li>● Stable network, Mic and camera testing</li>
            <li>● Click "Enter Class" 1-2 minutes in advance to avoid tardiness</li>
          </ul>
        </div>
      </div>
      <div class="flow-block">
        <div class="flow-title">During class<span></span></div>
        <div class="flow-text">
          <ul>
            <li>● Enough teaching time 25min</li>
            <li>● Systematic Blackboard writing</li>
            <li>● Need assistance/Avoid Argument-Contact CS </li>
          </ul>
        </div>
      </div>
      <div class="flow-block">
        <div class="flow-title">After class<span></span></div>
        <div class="flow-text">
          <ul>
            <li>● goodbye</li>
            <li>● Comment in time</li>
            <li>● No make up class due to student's side problem</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="sub-title">2. Talk915 Class Type</div>
    <div class="table">
      <div class="table-title">
        <div><span>Class Type</span></div>
        <div><span>Definition</span></div>
      </div>
      <div class="table-content">
        <div class="type-col">
          <div><span>EXP class</span></div>
          <div><span>Normal class</span></div>
          <div><span>VIP (Regular) class</span></div>
          <div><span>OC class</span></div>
          <div><span>GC Class</span></div>
        </div>
        <div class="definition-col">
          <div><span>Important Trial 1V1 class for new student</span></div>
          <div><span>1V1 class</span></div>
          <div><span>Regular schedule offered to VIP, who can submit more than 3 weeks regular schedule to you</span></div>
          <div><span>Open class/ Video Recording Class: Teacher can not see students and students listen/students watch video to learn.</span></div>
          <div><span>Students will sit in a same class room. They can see teacher through the big screen and students have the mobile microphone to answer the questions.</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less';
import { getUserType } from '@/utils/teacherAuth';
export default {
  methods: {
    // jumpPage() {
    //   const userType = getUserType();
    //   if (userType == 8) {
    //     let linkRouter = this.$router.resolve({ name: 'AgtAnnouncementDetail', query: { resId: 986 } });
    //     window.open(linkRouter.href, '_blank');
    //   } else if (userType == 1) {
    //     let linkRouter = this.$router.resolve({ name: 'AnnouncementDetail', query: { id: 986 } });
    //     window.open(linkRouter.href, '_blank');
    //   }
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/AgtPolicy/Introdution/index.vue